import moment from 'moment';
import React from 'react';

import './index.scss';

const AppointmentInfo = ({ details, selectedSchedule, getNameFromId }) => {
  const { slotdata } = selectedSchedule;
  console.log(
    'SERVICE',
    selectedSchedule,
    slotdata,
    getNameFromId(slotdata.resource_id, 'resources'),
  );
  return (
    <div className="client-profile__card">
      <h1 className="client-profile__card__heading">Appointment Info</h1>
      <div className="client-profile__card__content">
        <ul>
          <li>
            <span className="client-profile__card__content__list-head">
              Service Type:
            </span>
            <span className="client-profile__card__content__list-text">
              {getNameFromId(slotdata?.service_id, 'services')[0]
                ?.description || 'Other'}
            </span>
          </li>
          {/* <li>
              <span className="client-profile__card__content__list-head">
                Service code(s):
              </span>
              <span className="client-profile__card__content__list-text">
              
              </span>
            </li> */}
          <li>
            <span className="client-profile__card__content__list-head">
              Operatory:
            </span>
            <span className="client-profile__card__content__list-text">
              {getNameFromId(slotdata?.resource_id, 'resources')[0]?.name || ''}
            </span>
          </li>
          <li>
            <span className="client-profile__card__content__list-head">
              Provider:
            </span>
            <span className="client-profile__card__content__list-text">
              {getNameFromId(slotdata?.staff_id, 'staffs')[0]?.first_name +
                ' ' +
                getNameFromId(slotdata.staff_id, 'staffs')[0]?.last_name || ''}
            </span>
          </li>
          <li>
            <span className="client-profile__card__content__list-head">
              Starts:
            </span>
            <span className="client-profile__card__content__list-text">
              {moment(slotdata?.times?.slot?.start, 'HH:mm:ss').format(
                'h:mm A',
              )}
            </span>
          </li>
          <li>
            <span className="client-profile__card__content__list-head">
              Ends:
            </span>
            <span className="client-profile__card__content__list-text">
              {moment(slotdata?.times?.slot?.end, 'HH:mm:ss').format('h:mm A')}
            </span>
          </li>
          <li>
            <span className="client-profile__card__content__list-head">
              Location:
            </span>
            <span className="client-profile__card__content__list-text">
              {getNameFromId(slotdata?.location_id, 'locations')[0]
                ?.display_text || ''}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AppointmentInfo;
